import { createMuiTheme } from '@material-ui/core/styles';

export const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#279dd5',
        },
        secondary: {
            main: '#e1232e',
        }
    },
});
